// work data

export const Work = [
    {
        id:1,
        name:"Jaime",
        lastname: "Muñoz",
        description:"Profesor, cinturon negro 15° Dan",
    },
    {
        id:2,
        name:"Raul",
        lastname: "Hernandez",
        description:"Cinturón negro 5° Dan",
    },
    {
        id:3,
        name:"Herman",
        lastname: "Torres",
        description:"Cinturón negro 2° Dan",
    },
    {
        id:4,
        name:"Cristopher",
        lastname: "A.",
        description:"Cinturón negro 5° Dan",
    },
    {
        id:5,
        name:"Jimmy",
        lastname: "Berríos",
        description:"Cinturón verde 4° Kyu",
    },
    {
        id:4,
        name:"Victor",
        lastname: "Solis",
        description:"Cinturón verde 4° Kyu",
    },
    {
        id:4,
        name:"Jesus",
        lastname: "Berríos",
        description:"Cinturón verde 7° Kyu",
    }
  
] 